import {
  constants,
  typographyStyles
} from '@newsela/angelou';

import {breakpointSwitch} from '../../style';

const {colors: {ui}} = constants;

const commonChevronStyles = {
  width: '16px',
  height: '16px',
  transition: 'all 350ms ease-in-out',
  path: {
    strokeWidth: '3.5',
  }
};

export const itemLabelStyles = (isActive) => ({
  ...typographyStyles.textXSObj,
  lineHeight: '1.33',
  margin: '0',
  color: isActive ? ui.coreBlue['500'] : ui.grey['700'],
  gridArea: 'label',
  [breakpointSwitch]: {
    ...typographyStyles.textMObj,
    lineHeight: '1.5',
    color: isActive ? ui.greyDark['700'] : ui.grey['700'],
    marginRight: '4px',
    marginTop: 'unset'
  }
});

export const desktopSearchIconStyle = {
  ...commonChevronStyles,
  g: {
    ...commonChevronStyles.path,
    stroke: ui.grey['700'],
  },
  marginRight: '8px',
  circle: commonChevronStyles.path
};

export const desktopStyles = {
  marginRight: '16px',
};

export const desktopItemStyles = {
  display: 'flex',
  alignItems: 'center',
};

export const mobileStyles = {
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center'
};

export const caretStyle = (isActive) => ({
  transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
  path: {
    ...commonChevronStyles.path,
    stroke: isActive ? ui.greyDark['700'] : ui.grey['700'],
  },
  ...commonChevronStyles,
});
